<template>
    <div ref="scroller" class="listener-albums" @scroll.passive="listenBottomOut">
        <section class="listener-albums__hero">
            <div class="listener-albums__header">
                <div>
                    <div class="listener-albums__eyebrow">{{ $tt('专辑收藏') }}</div>
                    <h1 class="listener-albums__title">{{ pageTitle }}</h1>
                </div>
                <button
                    class="listener-albums__refresh"
                    :disabled="loading"
                    :title="$tt('刷新')"
                    @click="refreshCurrentPage"
                >
                <svg t="1781507668775" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2332" width="250" height="250"><path d="M797.538462 699.648h-27.569231a319.744 319.744 0 0 0 61.873231-188.908308A320.157538 320.157538 0 0 0 512.059077 190.976a39.384615 39.384615 0 0 0-39.384615 39.384615 39.384615 39.384615 0 0 0 39.384615 39.384616 241.289846 241.289846 0 0 1 241.014154 240.994461 240.955077 240.955077 0 0 1-46.020923 141.469539v-44.228923a39.384615 39.384615 0 0 0-39.384616-39.384616 39.384615 39.384615 0 0 0-39.384615 39.384616v131.052307a39.384615 39.384615 0 0 0 39.384615 39.384616h129.969231a39.384615 39.384615 0 0 0 39.384615-39.384616 39.384615 39.384615 0 0 0-39.483076-39.384615z" fill="#333333" p-id="2333"></path><path d="M512 754.235077a241.250462 241.250462 0 0 1-240.994462-240.974769 240.817231 240.817231 0 0 1 46.020924-141.371077v38.006154a39.384615 39.384615 0 0 0 39.384615 39.384615 39.384615 39.384615 0 0 0 39.384615-39.384615V278.843077a39.384615 39.384615 0 0 0-39.384615-39.384615h-129.969231a39.384615 39.384615 0 0 0-39.384615 39.384615 39.384615 39.384615 0 0 0 39.384615 39.384615h32.393846a319.369846 319.369846 0 0 0-66.619077 194.953846 320.118154 320.118154 0 0 0 319.763693 319.744 39.384615 39.384615 0 0 0 39.384615-39.384615A39.384615 39.384615 0 0 0 512 754.235077z" fill="#333333" p-id="2334"></path></svg>
                </button>
            </div>

            <div class="listener-albums__tabs">
                <button
                    v-for="{ value, text } in options"
                    :key="value"
                    :class="['listener-albums__tab', sortValue === value ? 'is-active' : '']"
                    @click="switchSort(value)"
                >
                    {{ $tt(text) }}
                </button>
            </div>

            <div class="listener-albums__summary">
                <div class="listener-albums__summary-kicker">{{ $tt('当前视图') }}</div>
                <div class="listener-albums__summary-title">
                    {{ pageTitle }}
                </div>
                <div class="listener-albums__summary-sub">
                    {{ summaryText }}
                </div>
                <div v-if="albums.length" class="listener-albums__actions">
                    <button class="listener-albums__action listener-albums__action--primary" @click="playAlbum(albums[0].id)">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l10-6.86a1 1 0 0 0 0-1.72l-10-6.86A1 1 0 0 0 8 5.14z"></path>
                        </svg>
                        <span>{{ $tt('播放第一张') }}</span>
                    </button>
                    <button class="listener-albums__action" @click="playRandomAlbum">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M17 3h4v4h-2V6.41l-3.29 3.3-1.42-1.42L17.59 5H17V3zM3 7h5l3.29 3.29-1.42 1.42L7.17 9H3V7zm18 10v4h-4v-2h.59l-3.3-3.29 1.42-1.42 3.29 3.3V17H21zM3 15h4.17l10-10H21V3h-4v2h.59L7.17 15H3v2z"></path>
                        </svg>
                        <span>{{ $tt('随机一张') }}</span>
                    </button>
                </div>
            </div>
        </section>

        <section v-if="albums.length" class="listener-albums__section">
            <div class="listener-albums__grid">
                <article
                    v-for="album in albums"
                    :key="album.id"
                    class="listener-albums__card"
                >
                    <div class="listener-albums__card-main">
                        <div class="listener-albums__image-wrap">
                            <button class="listener-albums__card-link" @click="openAlbum(album)">
                                <img
                                    :src="album.image || '/static/dist/img/album_null.jpg'"
                                    :alt="album.name"
                                    class="listener-albums__image"
                                >
                            </button>
                            <button class="listener-albums__play" @click.stop="playAlbum(album.id)">
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l10-6.86a1 1 0 0 0 0-1.72l-10-6.86A1 1 0 0 0 8 5.14z"></path>
                                </svg>
                            </button>
                        </div>
                        <button class="listener-albums__card-link listener-albums__card-link--meta" @click="openAlbum(album)">
                            <div class="listener-albums__name">{{ album.name }}</div>
                            <div class="listener-albums__artist">{{ album.artist || $tt('未知艺术家') }}</div>
                            <div class="listener-albums__meta">
                                <span>{{ album.year || '--' }}</span>
                                <span v-if="album.playsCount">{{ album.playsCount }} {{ $tt('次') }}</span>
                            </div>
                        </button>
                    </div>
                    <button class="listener-albums__fav" @click.stop="toggleFavourite(album)">
                        <svg viewBox="0 0 24 24" :fill="album.favourite ? '#ef4444' : 'none'" stroke="currentColor" stroke-width="2">
                            <path d="M12 21s-6.72-4.35-9.2-8.3A5.38 5.38 0 0 1 7.35 4.6 5.2 5.2 0 0 1 12 7.09 5.2 5.2 0 0 1 16.65 4.6a5.38 5.38 0 0 1 4.55 8.1C18.72 16.65 12 21 12 21z"></path>
                        </svg>
                    </button>
                </article>
            </div>
        </section>

        <section v-else-if="!loading" class="listener-albums__empty">
            <div class="listener-albums__empty-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                    <path d="M12 3a9 9 0 1 0 9 9A9 9 0 0 0 12 3zm0 6.5a2.5 2.5 0 1 1-2.5 2.5A2.5 2.5 0 0 1 12 9.5z"></path>
                </svg>
            </div>
            <h2>{{ $tt('还没有专辑') }}</h2>
            <p>{{ $tt('这个分类下暂时没有内容，切换一个筛选看看。') }}</p>
        </section>

        <section v-if="loading" class="listener-albums__state">
            <div class="listener-albums__loading"></div>
            <p>{{ $tt('正在加载...') }}</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'ListenerAlbumLibrary',
    data() {
        return {
            albums: [],
            loading: false,
            offset: 0,
            hasMore: true,
            curScrollTop: 0,
            presetOptions: [
                { text: '最近添加', value: 'recently-added', visible: true },
                { text: '最近播放', value: 'recently-played', visible: true },
                { text: '最多播放', value: 'most-played', visible: true },
                { text: 'A-Z排序', value: 'a-z', visible: true },
                { text: '歌手排序', value: 'artist-sort', visible: true },
                { text: '缺失封面', value: 'less_cover', visible: true },
            ],
            remoteOptions: []
        }
    },
    computed: {
        options() {
            const source = Array.isArray(this.remoteOptions) && this.remoteOptions.length
                ? this.remoteOptions
                : this.presetOptions
            return source.filter(option => option.visible !== false)
        },
        sortValue() {
            return this.$route.params.sort || 'recently-added'
        },
        pageTitle() {
            const current = this.options.find(item => item.value === this.sortValue)
            return current ? this.$tt(current.text) : this.$tt('专辑')
        },
        summaryText() {
            const map = {
                'recently-added': this.$tt('新收进来的专辑会先出现在这里，适合直接开始今天的播放。'),
                'recently-played': this.$tt('最近听过的专辑聚在这里，方便无缝续播。'),
                'most-played': this.$tt('这些是你最常回放的专辑，基本都是稳定命中。'),
                'a-z': this.$tt('按名称浏览整库，找专辑会更直接。'),
                'artist-sort': this.$tt('按艺术家线索整理，适合顺着人声和风格往下翻。'),
                'less_cover': this.$tt('这里是还缺封面的专辑，后续可以继续补全。')
            }
            return map[this.sortValue] || this.$tt('切换不同预设，快速浏览你的专辑收藏。')
        }
    },
    async created() {
        await this.loadSavedRules()
        this.loadMore()
    },
    activated() {
        this.$nextTick(() => {
            if (this.$refs.scroller) {
                this.$refs.scroller.scrollTop = this.curScrollTop || 0
            }
        })
    },
    methods: {
        resetState() {
            this.albums = []
            this.offset = 0
            this.hasMore = true
            this.curScrollTop = 0
            if (this.$refs.scroller) {
                this.$refs.scroller.scrollTop = 0
            }
        },
        async refreshCurrentPage() {
            if (this.loading) {
                return
            }
            await this.loadSavedRules()
            this.resetState()
            return this.loadMore()
        },
        async loadSavedRules() {
            try {
                const response = await this.$api.Task.getSys({ key: 'album_tabs' })
                if (response && response.data.items.length > 0) {
                    this.remoteOptions = JSON.parse(response.data.items[0].value)
                }
                if (!this.remoteOptions.length) {
                    this.remoteOptions = [...this.presetOptions]
                }
            } catch (error) {
                this.remoteOptions = [...this.presetOptions]
            }
        },
        loadMore() {
            if (this.loading || !this.hasMore) {
                return
            }
            this.loading = true
            return this.$api.subsonic.getAlbums(this.sortValue, 30, this.offset).then(albums => {
                this.albums.push(...albums)
                this.offset += albums.length
                this.hasMore = albums.length > 0
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        listenBottomOut() {
            if (!this.hasMore || this.loading || !this.$refs.scroller) {
                return
            }
            const scroller = this.$refs.scroller
            this.curScrollTop = scroller.scrollTop
            if (scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 120) {
                this.loadMore()
            }
        },
        switchSort(value) {
            if (value === this.sortValue) {
                return
            }
            this.$router.push({ path: '/albums/' + value })
        },
        openAlbum(item) {
            this.$router.push({ path: '/album/id/' + item.id })
        },
        async playAlbum(id) {
            const album = await this.$api.subsonic.getAlbumDetails(id)
            return this.$store.dispatch('playTrackList', {
                tracks: album.tracks
            })
        },
        playRandomAlbum() {
            if (!this.albums.length) {
                return
            }
            const target = this.albums[Math.floor(Math.random() * this.albums.length)]
            this.playAlbum(target.id)
        },
        toggleFavourite(item) {
            const action = item.favourite ? 'removeFavourite' : 'addFavourite'
            this.$api.subsonic[action](item.id, 'album').then(() => {
                item.favourite = !item.favourite
            })
        }
    }
}
</script>

<style scoped>
.listener-albums {
    height: calc(100dvh - 12.25rem);
    padding: 0.45rem 0.1rem 0.25rem;
    box-sizing: border-box;
    overflow-y: auto;
}

.listener-albums__hero {
    padding: 0.3rem 0.25rem 0.2rem;
}

.listener-albums__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
}

.listener-albums__eyebrow {
    font-size: 0.85rem;
    font-weight: 700;
    color: #94a3b8;
    letter-spacing: 0.04em;
}

.listener-albums__title {
    margin-top: 0.2rem;
    font-size: 2rem;
    line-height: 1;
    font-weight: 800;
    color: #111827;
    letter-spacing: -0.04em;
}

.listener-albums__refresh {
    width: 2.8rem;
    height: 2.8rem;
    border: 0;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.84);
    color: #0f172a;
    box-shadow: 0 12px 26px rgba(148, 163, 184, 0.14);
}

.listener-albums__refresh:disabled {
    opacity: 0.6;
}

.listener-albums__refresh svg {
    width: 2rem;
    height: 1.5rem;
}

.listener-albums__tabs {
    display: flex;
    gap: 0.55rem;
    overflow-x: auto;
    padding-bottom: 0.15rem;
    scrollbar-width: none;
}

.listener-albums__tabs::-webkit-scrollbar {
    display: none;
}

.listener-albums__tab {
    border: 0;
    border-radius: 999px;
    padding: 0.72rem 0.9rem;
    white-space: nowrap;
    background: rgba(255, 255, 255, 0.85);
    color: #64748b;
    font-size: 0.84rem;
    font-weight: 700;
    box-shadow: 0 10px 24px rgba(148, 163, 184, 0.1);
}

.listener-albums__tab.is-active {
    background: #111827;
    color: #fff;
    box-shadow: 0 16px 30px rgba(15, 23, 42, 0.2);
}

.listener-albums__summary {
    margin-top: 0.95rem;
    padding: 1rem;
    border-radius: 1.65rem;
    background: linear-gradient(135deg, rgba(17, 24, 39, 0.96), rgba(55, 65, 81, 0.92));
    color: #fff;
    box-shadow: 0 20px 46px rgba(15, 23, 42, 0.16);
}

.listener-albums__summary-kicker {
    font-size: 0.72rem;
    color: rgba(255, 255, 255, 0.64);
}

.listener-albums__summary-title {
    margin-top: 0.35rem;
    font-size: 1.08rem;
    font-weight: 700;
    line-height: 1.4;
}

.listener-albums__summary-sub {
    margin-top: 0.32rem;
    font-size: 0.8rem;
    line-height: 1.55;
    color: rgba(255, 255, 255, 0.68);
}

.listener-albums__actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.65rem;
    margin-top: 0.9rem;
}

.listener-albums__action {
    border: 0;
    border-radius: 1rem;
    padding: 0.78rem 0.65rem;
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.45rem;
    font-size: 0.82rem;
    font-weight: 700;
}

.listener-albums__action--primary {
    background: #fff;
    color: #111827;
}

.listener-albums__action svg {
    width: 1.02rem;
    height: 1.02rem;
}

.listener-albums__section {
    margin-top: 1rem;
}

.listener-albums__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.9rem 0.8rem;
    padding: 0 0.25rem 0.75rem;
}

.listener-albums__card {
    position: relative;
}

.listener-albums__card-main {
    width: 100%;
}

.listener-albums__card-link {
    width: 100%;
    border: 0;
    padding: 0;
    background: transparent;
    text-align: left;
}

.listener-albums__card-link--meta {
    margin-top: 0.75rem;
}

.listener-albums__image-wrap {
    position: relative;
}

.listener-albums__image {
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 1.35rem;
    box-shadow: 0 18px 32px rgba(148, 163, 184, 0.18);
}

.listener-albums__play {
    position: absolute;
    right: 0.75rem;
    bottom: 0.75rem;
    width: 2.6rem;
    height: 2.6rem;
    border: 0;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(17, 24, 39, 0.92);
    color: #fff;
    box-shadow: 0 12px 22px rgba(15, 23, 42, 0.22);
}

.listener-albums__play svg {
    width: 1rem;
    height: 1rem;
}

.listener-albums__fav {
    position: absolute;
    top: 0.6rem;
    right: 0.6rem;
    width: 2.2rem;
    height: 2.2rem;
    border: 0;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.86);
    color: #111827;
    box-shadow: 0 10px 18px rgba(148, 163, 184, 0.18);
}

.listener-albums__fav svg {
    width: 1rem;
    height: 1rem;
}

.listener-albums__name,
.listener-albums__artist {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.listener-albums__name {
    font-size: 0.95rem;
    font-weight: 700;
    color: #111827;
}

.listener-albums__artist {
    margin-top: 0.25rem;
    font-size: 0.8rem;
    color: #64748b;
}

.listener-albums__meta {
    margin-top: 0.45rem;
    display: flex;
    gap: 0.45rem;
    flex-wrap: wrap;
    font-size: 0.72rem;
    color: #94a3b8;
}

.listener-albums__empty,
.listener-albums__state {
    padding: 2.4rem 1rem 1rem;
    text-align: center;
    color: #64748b;
}

.listener-albums__empty h2 {
    margin-top: 0.85rem;
    font-size: 1.15rem;
    font-weight: 700;
    color: #111827;
}

.listener-albums__empty p,
.listener-albums__state p {
    margin-top: 0.45rem;
    font-size: 0.84rem;
    line-height: 1.6;
}

.listener-albums__empty-icon {
    width: 3.6rem;
    height: 3.6rem;
    margin: 0 auto;
    border-radius: 1.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);
    color: #94a3b8;
    box-shadow: 0 16px 32px rgba(148, 163, 184, 0.14);
}

.listener-albums__empty-icon svg {
    width: 1.6rem;
    height: 1.6rem;
}

.listener-albums__loading {
    width: 2.4rem;
    height: 2.4rem;
    margin: 0 auto;
    border-radius: 999px;
    border: 3px solid rgba(148, 163, 184, 0.24);
    border-top-color: #111827;
    animation: listener-albums-spin 0.75s linear infinite;
}

@keyframes listener-albums-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
